import React from 'react'
import CurrencyInputComponent from 'react-currency-input'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'

const CurrencyInput = props => {
  return <Input decimalSeparator=',' thousandSeparator='.' prefix='R$ ' onChangeEvent={props.onChange} {...props} />
}

const Input = styled(CurrencyInputComponent)`
  ${({ disabled }) => `
    border-radius: 4px;
    height: 40px;
    width: 100%;
    transition: all 0.2s ease-in-out;
    font-size: 14px;
    outline: none;
    border: 1px solid gray;
    padding: 0 10px;
    background: ${disabled ? 'gray' : ''};
  `}
  &:focus {
    border: 1px solid #076f9f;
  }
`

export default withTheme(CurrencyInput)
